import { Warning } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Typography } from "@mui/material";

export const PlantSelectionMessage = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <Box textAlign="center" maxWidth={500}>
      <Warning sx={{ fontSize: 60, color: "text.secondary", mb: 2 }} />
      <Typography
        variant="h5"
        component="h3"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        Selecciona una planta
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Para ver los equipos y datos de mantenimiento, primero debes seleccionar
        una planta desde el selector superior.
      </Typography>
      <Alert severity="info" sx={{ mt: 3 }}>
        <AlertTitle>Información</AlertTitle>
        Una vez seleccionada la planta, podrás acceder a toda la información de
        equipos y mantenimientos.
      </Alert>
    </Box>
  </Box>
);
